
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entidade"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obrasServicosDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entidade"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entidade"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numero"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"descricao"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"apelido"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tipo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"regiao"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"secretaria"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"situacao"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"situacaoDescricao"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"latitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"longitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"localizacao"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"valor_total"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"valor_total_contratos"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numero_contrato"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cpf_cnpj"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nome_contratado"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"progresso"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ano"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"data_inicio"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previsao_termino"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previsao_termino_inicial"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ultima_modificacao"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":448}};
    doc.loc.source = {"body":"query ($entidade: Int!) {\n  obrasServicosDetails(entidade: $entidade) {\n    id\n    numero\n    descricao\n    apelido\n    tipo\n    regiao\n    secretaria\n    situacao\n    situacaoDescricao\n    latitude\n    longitude\n    url\n    localizacao\n    valor_total\n    valor_total_contratos\n    numero_contrato\n    cpf_cnpj\n    nome_contratado\n    progresso\n    ano\n    data_inicio\n    previsao_termino\n    previsao_termino_inicial\n    ultima_modificacao\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
